import { styled } from "@mui/system";

export const ButtonWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
}));

export const ComplianceHeader = styled("p")(({ theme }) => ({
  marginTop: 0
}));
